import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetOrganization,
  UpdateOrganization,
} from "../../../store/organization-store/organization-actions";
import OrganizationForms from "../../../components/Forms/OrganizationForms";
import { getTokenInfo } from "../../../utils/Guard";

const OrganizationEdit = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const organization = useSelector((state) => state.organization.organization);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (organization.id===undefined || organization.id === 0) {
      dispatch(GetOrganization(param.organizationId, userInfo.Email));
    }
  }, [param.organizationId, userInfo.Email, dispatch, organization]);

  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "62.5rem" }}>
      <OrganizationForms actionOrganization={UpdateOrganization} organization={organization} />
    </div>
    </>
  );
};
export default OrganizationEdit;
